/* eslint-disable no-param-reassign */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Channel, Tactic } from 'generated/maya.types';

const useMiViewCEPAccordion = (tactics: Tactic[], opened: boolean) => {
  const { t } = useTranslation();
  const [openedState, setOpenedState] = useState(opened);
  const [formattedTactics, setFormattedTactics] = useState<Tactic[]>([]);

  const changeOpenState = () => {
    setOpenedState(!openedState);
  };

  const extractLastNumber = (formattedId: string): number => {
    if (!formattedId) return 0;
    const parts = formattedId.split('-');
    const lastPart = parts[parts.length - 1];
    const num = parseInt(lastPart, 10);
    // eslint-disable-next-line no-restricted-globals
    return isNaN(num) ? 0 : num;
  };

  const getChildTactics = (tactic: Tactic) => {
    const childTactics = tactics.filter((tacticItem) => tacticItem?.parentTactic?._id === tactic._id)
      ?.sort((a: Tactic, b: Tactic) => {
        return extractLastNumber(a.formattedTacticId) - extractLastNumber(b.formattedTacticId);
      }) || [];

    return childTactics;
  };

  const getActionOrder = (tactic: Tactic) => {
    if (tactic.channel !== Channel.group) {
      return tactic.actionOrder;
    }

    const childTactics = getChildTactics(tactic);
    return childTactics?.length ? childTactics[0].actionOrder : 0;
  };

  const getStartDate = (tactic: Tactic) => {
    const childTactics = getChildTactics(tactic);
    return childTactics?.length ? childTactics[0].dateStart : '';
  };

  const getEndDate = (tactic: Tactic) => {
    const childTactics = getChildTactics(tactic);
    return childTactics?.length ? childTactics[0].dateEnd : '';
  };

  useEffect(() => {
    const updatedTactics = tactics?.filter((tactic) => !tactic.parentTactic).map((tactic) => {
      if (tactic.channel === Channel.group) {
        tactic.title = t('maya_miview_tactic_group_channel_label');
        tactic.actionOrder = getActionOrder(tactic);
        tactic.dateStart = getStartDate(tactic);
        tactic.dateEnd = getEndDate(tactic);
      }

      return tactic;
    })?.sort((a: Tactic, b: Tactic) => Number(a.actionOrder) - Number(b.actionOrder));

    setFormattedTactics(updatedTactics);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tactics]);

  return {
    openedState,
    changeOpenState,
    formattedTactics,
  };
};

export default useMiViewCEPAccordion;
